module.exports = __webpack_public_path__ + "img/portrait-098.34a65a35.jpg";